import React from "react";
import {
  Navigate,
  Route,
  Routes,
} from "react-router-dom";

import Home from "./Home";
import PrivateRoute from "./PrivateRoute";
import PrivateLayout from "./PrivateLayout";
import AdminDashboard from "./Dashboards/AdminDashboard";
import AgentDashboard from "./Dashboards/AgentDashboard";
import PolicyholderDashboard from "./Dashboards/PolicyholderDashboard";
import SettingsHub from "./Settings/SettingsHub";
import ProfileSettings from "./ProfileSettings";
import ProposalWorkspace from "./Proposals/ProposalWorkspace";
import PolicyWorkspace from "./Policies/PolicyWorkspace";
import MemberWorkspace from "./Members/MemberWorkspace";
import PolicyMaintenanceWorkspace from "./PolicyMaintenance/PolicyMaintenanceWorkspace";
import PolicyPaymentWorkspace from "./PolicyPayments/PolicyPaymentWorkspace";
import ClaimsWorkspace from "./Claims/ClaimsWorkspace";
import CommissionWorkspace from "./Commissions/CommissionWorkspace";
import FinanceWorkspace from "./Finance/FinanceWorkspace";
import ExpenditureWorkspace from "./Expenditure/ExpenditureWorkspace";
import InsuranceReportsWorkspace from "./Reports/InsuranceReportsWorkspace";
import AuditTrailWorkspace from "./AuditTrail/AuditTrailWorkspace";
import AssuranceAIWorkspace from "./AI/AssuranceAIWorkspace";
import ForgotPassword from "./Auth/ForgotPassword";
import ResetPassword from "./Auth/ResetPassword";
import ChangePassword from "./Auth/ChangePassword";
import NotificationInbox from "./Communications/NotificationInbox";
import CommunicationWorkspace from "./Communications/CommunicationWorkspace";
import EcoSureWorkspace from "./EcoSure/EcoSureWorkspace";
import EcoSurePartnerDashboard from "./EcoSurePartner/EcoSurePartnerDashboard";
import BulkImportsWorkspace from "./BulkImports/BulkImportsWorkspace";

function Main() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        element={
          <PrivateRoute
            allowedAccessTypes={[
              "SYSTEM_USER",
              "AGENT",
              "POLICY_HOLDER",
              "PARTNER",
            ]}
          />
        }
      >
        <Route path="/change-password" element={<ChangePassword />} />
        <Route element={<PrivateLayout />}>
          <Route
            path="/notifications"
            element={<NotificationInbox />}
          />
        </Route>
      </Route>

      <Route
        element={
          <PrivateRoute
            allowedAccessTypes={["SYSTEM_USER"]}
          />
        }
      >
        <Route element={<PrivateLayout />}>
          <Route
            element={
              <PrivateRoute
                allowedRoles={["DIRECTOR", "SYSTEM ADMINISTRATOR"]}
              />
            }
          >
            <Route path="/dashboard" element={<AdminDashboard />} />
          </Route>
          <Route path="/proposals" element={<ProposalWorkspace />} />
          <Route path="/members" element={<MemberWorkspace />} />
          <Route path="/policies" element={<PolicyWorkspace />} />
          <Route path="/policy-maintenance" element={<PolicyMaintenanceWorkspace />} />
          <Route path="/policy-payments/:policyId" element={<PolicyPaymentWorkspace />} />
          <Route path="/claims" element={<ClaimsWorkspace />} />
          <Route path="/commissions" element={<CommissionWorkspace />} />
          <Route path="/finance" element={<FinanceWorkspace />} />
          <Route path="/expenditure" element={<ExpenditureWorkspace />} />
          <Route path="/ecosure" element={<EcoSureWorkspace />} />
          <Route path="/bulk-imports" element={<BulkImportsWorkspace />} />
          <Route path="/insurance-reports" element={<InsuranceReportsWorkspace />} />
          <Route path="/audit-trail" element={<AuditTrailWorkspace />} />
          <Route path="/assurance-ai" element={<AssuranceAIWorkspace />} />
          <Route path="/communications" element={<CommunicationWorkspace />} />
          <Route
            path="/settings"
            element={<SettingsHub />}
          />
          <Route
            path="/profile"
            element={<ProfileSettings />}
          />
        </Route>
      </Route>

      <Route
        element={
          <PrivateRoute allowedAccessTypes={["AGENT"]} />
        }
      >
        <Route element={<PrivateLayout />}>
          <Route
            path="/agent/dashboard"
            element={<AgentDashboard />}
          />
          <Route
            path="/agent/proposals"
            element={<ProposalWorkspace />}
          />
          <Route
            path="/profile"
            element={<ProfileSettings />}
          />
        </Route>
      </Route>

      <Route
        element={
          <PrivateRoute
            allowedAccessTypes={["POLICY_HOLDER"]}
          />
        }
      >
        <Route element={<PrivateLayout />}>
          <Route
            path="/policyholder/dashboard"
            element={<PolicyholderDashboard />}
          />
          <Route
            path="/profile"
            element={<ProfileSettings />}
          />
        </Route>
      </Route>

      <Route element={<PrivateRoute allowedAccessTypes={["PARTNER"]} />}>
        <Route element={<PrivateLayout />}>
          <Route path="/partner/ecosure" element={<EcoSurePartnerDashboard initialTab="dashboard" />} />
          <Route path="/partner/ecosure/clients" element={<EcoSurePartnerDashboard initialTab="clients" />} />
          <Route path="/partner/ecosure/remittances" element={<EcoSurePartnerDashboard initialTab="remittances" />} />
          <Route path="/partner/ecosure/reports" element={<EcoSurePartnerDashboard initialTab="reports" />} />
          <Route path="/profile" element={<ProfileSettings />} />
        </Route>
      </Route>

      <Route
        path="*"
        element={<Navigate to="/" replace />}
      />
    </Routes>
  );
}

export default Main;
